<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<draggable-container #draggableContainer [showIcon]="false">
	<div class="meeting-popup__vertical-flex">
		<div class="meeting-popup__nav-bar meeting-popup__nav-bar-zindex">
			<button
				class="legacy-button btn--red"
				style="margin-right: 14px"
				*ngIf="(meetingJoined$ | async) && (this.planAccessCheck.isAdmin$ | async)"
				(click)="endMeeting()"
			>
				End Meeting
			</button>
			<!-- <a class="meeting-popup__link" *ngIf="userProcessedUrl$ | async as meetingUrl" [href]="meetingUrl" target="_">Open externally</a> -->
			<!-- <button (click)="close()">Close</button>  -->
			<div class="meeting-popup__nav-bar-spacer"></div>
			<a
				href="https://intercom.help/touchplanio/en/articles/3853794-video-chatting-in-touchplan"
				target="_"
				class="meeting-popup__help-link"
				>Help/ FAQ</a
			>
			<i class="material-icons meeting-popup__nav-bar--icons" (click)="close()">close</i>
		</div>
		<div class="meeting-popup__button-wrapper">
			<button
				class="legacy-button meeting-popup__show-video-button"
				*ngIf="(userProcessedUrl$ | async) && !(meetingJoined$ | async)"
				(click)="joinMeeting()"
			>
				Show video
			</button>

			<div class="meeting-popup__create-meeting" *ngIf="!(userProcessedUrl$ | async)">
				<ng-container *ngIf="this.planAccessCheck.isAdmin$ | async">
					<div style="margin-bottom: 20px" class="meeting-popup__title">
						Select Video Host
						<select [formControl]="videoHost">
							<option value="zoom">Zoom.us</option>
							<option value="jitsi">Peer to Peer</option>
						</select>
					</div>

					<!-- <div class="meeting-popup__explanation">Jitsi is a meeting provider that </div> -->

					<!-- Zoom specific setup-->
					<ng-container *ngIf="videoHost.value === 'zoom'">
						<div class="meeting-popup__title">Join Meeting</div>
						<div class="meeting-popup__explanation">
							Paste a Zoom meeting link to start a shared meeting. Or
							<a class="meeting-popup__link" href="https://zoom.us/meeting" target="_">create a meeting</a> if
							you don't have a link.
						</div>
						<!-- <div>
							<a href="https://zoom.us/meeting" target="_">Create a meeting</a>
						</div> -->
						<div class="meeting-popup--valign-wrap">
							<input
								class="meeting-popup__input"
								placeholder="https://zoom.us/j/zzz?pwd=yyy"
								[formControl]="url"
							/>
							<button class="legacy-button" style="margin-left: 5px" (click)="setUrl(url.value)">
								Start
							</button>
						</div>
					</ng-container>

					<!-- Jitsi specific setup-->
					<ng-container *ngIf="videoHost.value === 'jitsi'">
						<div class="meeting-popup__title">Join Meeting</div>
						<div class="meeting-popup__explanation">
							Create a direct peer to peer meeting using
							<a class="meeting-popup__link" href="https://meet.jit.si" target="_">Jit.si</a> as the
							coordinator.
						</div>
						<!-- <div>
							<a href="https://zoom.us/meeting" target="_">Create a meeting</a>
						</div> -->
						<div class="meeting-popup--valign-wrap">
							<!-- <input class="meeting-popup__input" placeholder="https://meet.jit.si/Something" [formControl]="url"> -->
							<button class="legacy-button" style="margin-left: 5px" (click)="setJitsiUrl()">
								Start Meeting
							</button>
						</div>
					</ng-container>
				</ng-container>
				<ng-container *ngIf="!(this.planAccessCheck.isAdmin$ | async)">
					<div class="meeting-popup__explanation">Waiting for an admin to start the meeting.</div>
				</ng-container>
			</div>
		</div>

		<div class="meeting-popup__iframe-wrapper">
			<iframe
				*ngIf="(meetingJoined$ | async) && (userProcessedUrl$ | async)"
				class="meeting-popup__iframe"
				[src]="userProcessedSanitizedUrl$ | async"
				sandbox="allow-same-origin allow-forms allow-scripts"
				allow="microphone; camera; autoplay"
			></iframe>
		</div>
	</div>
</draggable-container>
